<template>
    <f7-page name="todoitems" color-theme="teal">
        <f7-navbar :title="groupname" back-link="">

            <f7-nav-right>
                <f7-link icon-if-ios="f7:menu" icon-if-md="material:menu" panel-open="right"></f7-link>
            </f7-nav-right>
        </f7-navbar>
        <f7-list class='uncompletedList' media-list>
            <f7-list-item
                    v-for="(item) in items" :key="item.ID"
                    :checkbox="(!showStepper 
                    && editFilter() == null) || !('time' in item)"
                    :title="item.description"
                    :value="item.ID"
                    :text="(item.amount > 0
                        ? item.amount+(item.sizeID > 0
                            ? ' x '
                            : '')
                        : '') + (item.sizeID > 0
                        ? item.sizedescription+(item.comment == ''
                            ? ''
                            : ' | ')
                        : '') + (item.comment ? item.comment : '')"
                    @change="removeItem"
                    @taphold.native="tabHold(item)"
                    :data-id="item.ID"
            >
            <f7-stepper :manual-input-mode="true" 
                @stepper:change="setAmount($event, item.ID)"
                :min="0"
                :max="1000"
                :value="item.amount" 
                :id="item.ID + '-week-item'"
                :data-id="item.ID"
                v-if="(showStepper || editFilter() != null)
                && ('time' in item)" slot="after" fill small>
            </f7-stepper>
            </f7-list-item>
        </f7-list>
        <f7-block>
            <f7-row tag="p">
                <f7-col tag="span">
                    <f7-button big small fill v-if="completedList" @click.prevent="toggleCompledList" color-theme="teal">Complete to-dos</f7-button>
                    <f7-button big small fill v-else @click.prevent="toggleCompledList" color-theme="teal">Show completed to-dos</f7-button>
                </f7-col>
            </f7-row>
        </f7-block>
        <f7-list v-if="completedList" media-list>
            <f7-list-item
                    v-for="(completeditem) in completeditems" :key="completeditem.ID"
                    checkbox
                    checked
                    :title="completeditem.description"
                    :value="completeditem.ID"
                    :text="completeditem.comment"
                    @change="restoreItem"
                    class="completeItem"
            ></f7-list-item>
        </f7-list>
    </f7-page>
</template>

<script>
    import Vue from 'vue';

    export default {
        props: ['groupID'],
        data() {
            return {
                tokenValue: {},
                token: localStorage.getItem('token'),
                user: {},
                groupname: '',
                completedList: false,
                showEditItems: [],
                showStepper: false,
            }
        },
        watch: {
            isAuth(val) {
                if(val==false) {
                    this.$f7router.navigate('/login');
                }
            }
        },
        computed: {
            isAuth() {
                return this.$store.getters['admin/isAuth']
            },
            todo(){
                return this.$store.getters['todo/getTodo']
            },
            items(){
                return this.$store.getters['todo/getItems'](this.groupID);
            },
            completeditems(){
                return this.$store.getters['todo/getCompletedItems'](this.groupID)
            }
        },
        methods: {
            tabHold(item) {
                if (item.time) {
                    this.showStepper = true;
                }
            },
            getItems() {
                //this.tokenValue = this.$parseJWT(this.token);
                this.$store.dispatch('todo/getItems');
            },
            getGroupName() {
                for (var key in this.todo.groups) {
                    if (key == this.groupID) {
                        this.groupname = this.todo.groups[key].name;
                    }
                }
            },
            removeItem(event) {
                if(event.target.checked == true) {
                    var itemID = event.target.value;

                    for(var i=0;i<this.items.length;i++) {
                        if(this.items[i].ID == itemID) {
                            var item = this.items[i];
                        }
                    }

                    this.$store.dispatch('todo/setItemDone',item);
                }
            },
            restoreItem(event) {
                if(event.target.checked == false) {
                    var itemID = event.target.value;

                    for(var i=0;i<this.completeditems.length;i++) {
                        if(this.completeditems[i].ID == itemID) {
                            var item = this.completeditems[i];
                        }
                    }

                    this.$store.dispatch('todo/setItemUnDone',item);
                }
            },
            setAmount(val, itemID) {
                this.$store.dispatch('todo/updateWeekItem',{
                    ID: itemID,
                    amount: val
                });
            },
            toggleCompledList() {
                if(this.completedList == false) {
                    this.completedList = true;
                }else{
                    this.completedList = false;
                }
            },
            editFilter() {
                return JSON.parse(localStorage.getItem('edit'));
            }
        },
        created() {
            this.getGroupName();
        }
    };
</script>

<style>
    .completeItem {
        text-decoration: line-through;
    }

    .stepper-button, .stepper-button-minus, .stepper-button-plus {
    background-color:#008080 !important;
    }

    .md .stepper .stepper-value, .md .stepper .stepper-input-wrap input {
        color: #008B8B !important;
    }

    .md .stepper-value, .md .stepper-input-wrap {
        border-top: 2px solid #008080 !important;
        border-bottom: 2px solid #008080 !important;
    }


    .icon {
        cursor: pointer;
        -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
    }
</style>